import request from "../base";
const path = "/api/data/x-accounts";

export default {
  get: function (params) {
    return request().post(path + "/", params);
  },
  delete: function(filter) {
    filter.type = 'soft';

    return request().delete(path + "/", {
      data: filter
    });
  },
  import: function({attachments, template, delimiter, accounts, duplicateCheck, tags}) {
    let data = new FormData();

    if (attachments && attachments.length > 0) {
      attachments.forEach(attachment => {
        data.append('attachments', attachment);
      });
      data.append('type', 'file');
      data.append('template', template);
      data.append('delimiter', delimiter || '|');
      tags.forEach(tag => {
        data.append('tags', tag);
      });

      if (duplicateCheck) {
        data.append('duplicate_check', duplicateCheck);
      }
    } else {
      data = {
        type: 'json',
        accounts: accounts,
        tags: tags
      }

      if (duplicateCheck) {
        data.duplicate_check = duplicateCheck;
      }
    }
  
    return request().post(path + "/method/import", data);
  },
  createCheckLiveUidsTask: function(uids) {
    return request().post(path + "/check-live-uid", {uids: uids});
  },
  createCheckLiveFilterTask: function(params) {
    return request().post(path + "/check-live-filter", params);
  },
  getCheckLiveTask: function(params) {
    return request().post(path + "/check-live", params);
  },
  checkLiveEmailFilter: function(params) {
    return request().post(path + "/check-live-email-filter", params);
  },
  getById: function (id) {
    return request().get(path + "/" + id);
  },
  unassignTag: function(params) {
    return request().post(`${path}/${params.id}/unassign-tag`, {tag_id: params.tag_id});
  },
  unassignTagByFilter: function(params) {
    return request().post(path + "/unassign-tag-filter", params);
  },
  export: function(params) {
    return request().post(path + "/method/export", params);
  },
  getXCookies: function() {
    return request().get(path + "/method/x-cookies");
  },
  setXCookies: function(params) {
    return request().post(path + "/method/x-cookies", params);
  },
  addJobInputs: function(params, jobPid) {
    return request().post(path + "/method/add-job-inputs", params, {
      params: {
        job_pid: jobPid
      }
    });
  },
  countDeletedData: function() {
    return request().post(path + "/count-deleted");
  },
  removeTrash: function() {
    return request().delete(path + "/remove-trash");
  },
  restoreTrash: function() {
    return request().post(path + "/restore-trash");
  },
};
